<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import BrandGlyphField from './BrandGlyphField.vue';
import SideNav from './SideNav.vue';
import TopBar from './TopBar.vue';

const route = useRoute();
const fullBleed = computed(() => route.meta.fullBleed === true);
const navigationOpen = ref(false);
watch(() => route.fullPath, () => { navigationOpen.value = false; });
</script>

<template>
    <div class="shell">
        <BrandGlyphField class="shell__glyphs" />
        <SideNav id="shell-navigation" :class="{ 'side-nav--open': navigationOpen }" />
        <TopBar :navigation-open="navigationOpen" @toggle-navigation="navigationOpen = !navigationOpen" />
        <main class="shell__main" :class="{ 'shell__main--full-bleed': fullBleed }">
            <slot />
        </main>
    </div>
</template>

<style scoped>
.shell {
    position: relative;
    display: grid;
    grid-template-columns: 220px minmax(0, 1fr);
    grid-template-rows: auto 1fr;
    grid-template-areas:
        'nav top'
        'nav main';
    height: 100%;
    background: var(--shell-bg);
    overflow: hidden;
}
.shell__glyphs {
    position: absolute;
    inset: 0;
    z-index: 0;
}
.shell__main {
    min-width: 0;
    min-height: 0;
    position: relative;
    grid-area: main;
    z-index: 1;
    overflow: auto;
    padding: 24px 28px 48px;
}

/* Full-bleed pages (graph editor, etc.) — no padding, fill height */
.shell__main--full-bleed {
    padding: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

/* TopBar must be above main content so dropdowns overlay it */
:deep(.top-bar) {
    z-index: 10;
}

@media (max-width: 900px) {
    .shell {
        grid-template-columns: 1fr;
        grid-template-rows: auto minmax(0, auto) minmax(0, 1fr);
        grid-template-areas:
            'top'
            'nav'
            'main';
        height: 100dvh;
    }
    .shell__main {
        padding: 20px 16px 40px;
    }
    .shell__main--full-bleed { padding: 0; }
}
</style>
